import React, { FC, useEffect, useMemo } from "react";
import { DrawerComponent, IFrameComponent } from "components";
import { MAIN_SITE } from "../../../constants";
import { getToken } from "utils";
import { PAGES } from "../../../constants/pages";
import { usePermissionsState } from "context";

const ContactEmbedded: FC<{
  isOpen: boolean;
  onClose: () => void;
  contactId: string;
  contactType: string;
  teamId: number;
}> = ({ isOpen, onClose, contactId, contactType, teamId }) => {
  const { permission } = usePermissionsState();

  const link = useMemo(() => {
    const getItemLinkParams = new URLSearchParams({
      token: String(getToken().accessToken),
      refreshToken: String(getToken().refreshToken),
      isBusinessProfile: "true",
      contactId: String(contactId),
      teamId: String(teamId),
      redirectTo: `${PAGES.CONTACT_DETAILS}${contactType}/${contactId}`,
      role: permission?.role || "",
    }).toString();

    return `${MAIN_SITE}/o/auth/login-with-token?${getItemLinkParams}`;
  }, [contactId, contactType, teamId, permission?.role]);

  useEffect(() => {
    const handleMessage = (event: MessageEvent<any>) => {
      if (event.data.close) {
        onClose();
      }
    };
    window.addEventListener("message", handleMessage, false);
    return () => {
      window.removeEventListener("message", handleMessage, false);
    };
  }, []);

  return (
    <DrawerComponent isOpen={isOpen} onClose={onClose}>
      <IFrameComponent srcLink={link} height="100%" width="100%" />
    </DrawerComponent>
  );
};

export default ContactEmbedded;
